export default function ComplianceNote() {
  return (
    <div className="mt-8 text-center text-xs text-muted-foreground">
      Flexaura operates as a financing marketplace and comparison platform. Selected providers are
      regulated in the UAE. Terms, eligibility, and fees are shown before checkout. Open-banking and
      additional integrations are being rolled out in phases.
    </div>
  );
}